import { ReactNode } from "react";
import styles from "./AnalyticsStat.module.scss";
import { AnalyticsCardType } from "../card/AnalyticsCard";

type Props = {
	label: string;
	/** Already formatted for display, e.g. "3,180". */
	value: string;
	/** Sits opposite the label, e.g. the share the figure works out to. */
	aside?: ReactNode;
	/**
	 * The line under the value — an AnalyticsTrend for a comparison, or plain text for
	 * what the figure covers.
	 */
	note?: ReactNode;
	/** Tints the box and the value. The label is what says which problem it is. */
	tone?: AnalyticsCardType;
};

/** One figure in a box, for a card that holds several of them next to other content. */
const AnalyticsStat = ({ label, value, aside, note, tone }: Readonly<Props>) => (
	<div className={`${styles.stat} ${tone ? `${styles.toned} ${styles[tone]}` : ""}`}>
		<div className={styles.labelRow}>
			<span className={styles.label}>{label}</span>
			{aside && <span className={styles.aside}>{aside}</span>}
		</div>
		<span className={styles.value}>{value}</span>
		{note && <div className={styles.note}>{note}</div>}
	</div>
);

export default AnalyticsStat;
